// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logged_user{
    align-tracks: left;
    font-weight: bold;
}

.text-content {
    padding-left: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}
.button {
    background-color:  #0066b2;
    color: white;
}
.grid-buttons{
    display: flex;
     gap: 10px;
  }`, "",{"version":3,"sources":["webpack://./src/app/modules/permanentdelegation/home/delegation/delegation.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,0BAA0B;IAC1B,YAAY;AAChB;AACA;IACI,aAAa;KACZ,SAAS;EACZ","sourcesContent":[".logged_user{\n    align-tracks: left;\n    font-weight: bold;\n}\n\n.text-content {\n    padding-left: 20%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n}\n.button {\n    background-color:  #0066b2;\n    color: white;\n}\n.grid-buttons{\n    display: flex;\n     gap: 10px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
